import styled from '@emotion/native'
import React, { FC } from 'react';

import { Row } from '@components/1-atoms/Miscellaneous';

import Text from '@components/1-atoms/Text';

const Container = styled(Text)`
color: ${({ color, theme }: any) => color || theme.gray_2};
font-weight: bold;
font-size: 16px;
line-height: 19px;
margin-bottom: 6px;
`;

const Mark = styled(Text)`
color: ${({ color, theme }: any) => color || theme.red};
`;


const SectionTitle: FC<Props> = ({  children, required, style, ...props }) => {
    return (
      <Row>
        <Container style={style} {...props}>
          {children}
          {required ? <Mark> *</Mark> : null}
        </Container>
      </Row>
    );
  }

  type Props = {
    children: React.ReactNode | Text;
    required?: boolean;
    style?: object;
    color?: string;
  };

  export default SectionTitle;